module.exports = __webpack_public_path__ + "img/postIcon.1797863e.png";